// user api
// export const USER_LOGIN = "/userapi/phlogin";
export const USER_LOGIN = "/userapi/login";
export const USER_REGISTRATION = "/userapi/phregistration";
export const UPDATE_USER_PROFILE = "/userapi/updateuserprofile";

// get aLL users
export const GET_ALL_USERS = "/userapi/getusersfr";

// country
export const GET_COUNTRIES = "/commonapi/getcountries";

// Assessment
export const GET_USERS_ASSESSMENT = "/userassessmentapi/getassessmentsfr";
export const GET_USER_ASSESSMENT = "/userassessmentapi/getassessmentsfr";

// updateUserPassword 
export const UPDATE_USER_PASSWORD = "/userapi/updateuserpassword";

// forgot password 
export const FORGOT_PASSWORD = "/userapi/updateuserprofile";

// get aLL employees
export const GET_ALL_EMPLOYEES = "/userapi/getemployeesfr";

// company
export const GET_COMPANIES = "/userapi/getcompanies";

// employees
export const ADD_EMPLOYEE = "/userapi/addemployee";

export const GET_EMPLOYEE_BY_ID = "/userapi/getemployeesfr";

export const UPDATE_EMPLOYEE = "/userapi/updateemployee";

export const GET_ALL_RESOURCES = "/resourceapi/getresourcesfr";

export const UPDATE_RESOURCES_EMAIL_STATUS = "/resourceapi/updateresourceemailstatus";

export const SEND_RESOURCES_EMAIL = "/resourceapi/sendemail";
